module.exports = __webpack_public_path__ + "static/media/Patreon1_Support_512.af7b1d82.png";